<mat-icon style="float: right"><span (click)="clear()">clear</span></mat-icon>
